import React, { useEffect, useState, Suspense } from "react";
import withToasts from "hoc/withToasts";
import { connect } from "react-redux";
// import { pushItemsToCart } from "store/actions/cart.action";
import { useDispatch } from "react-redux";
import HomeHeader from "containers/Home/HomeHeader/HomeHeader";
import "containers/DispenseLater/DispenseLater.css";
import { successlogo } from "constants/images";
import { useSelector } from "react-redux";
//Lazy loading.
import Button from "components/Button/Button";
import { APP_ROUTES } from "constants/routes";
import { Link } from "react-router-dom";
import useCart from "hooks/useCart";
import UserDetailsHeader from "containers/UserDetails/UserDetailsHeader/UserDetailsHeader";
import Timer from "components/Timer/Timer";
import CountdownTimer from "components/CountdownTimer/CountdownTimer";
import "../UserDetails/UserDetails.css";
import { requestPostFetchApi } from "utils/apiMethods";
import { API_KEYS } from "constants/apiEndpoints";
import { getUserHashToken, getUserPhone } from "utils/commonMethods";
// const Footer = React.lazy(() => import("containers/Footer/Footer"));
import useAuthentication from "hooks/useAuthentication";
import AlertModal from "components/AlertModal/AlertModal";
// import VendingLogo from "../../../public/images/Vending_machine.png";
function DispenseLater({
  history,
  location,
  showErrorToast,
  showSuccessToast,
}) {
  const DISPENSE_WAITING = null,
    DISPENSE_FAILURE = 0,
    DISPENSE_SUCCESS = 1,
    API_POLLING_INTERVAL = 10000; //in milliseconds;
  const componentTexts = window.appTexts.dispense_later;
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);
  const { getUserId } = useAuthentication();
  const cUID = useSelector((state) => state.orderReducer.cUID); //Cart Unique Identifier
  const { currentCartItems } = useCart();
  const [showRequestProduct, setShowRequestProduct] = useState(false);
  const [showPaymentStatusModal, setShowPaymentStatusModal] = useState(false);
  const [vendDispenseCompleted, setVendStatusCompleted] = useState(false);
  const [errorOccured, setErrorOccured] = useState(false);

  const DispenseNowButton = () => {};
  // <Link to={APP_ROUTES.LOGIN.url}>
  //   <Button>{componentTexts.add_button_dispense_now}</Button>
  // </Link>

  //cancel order api payload
  let createCancelOrderPayload = {
    cUID: cUID.toString(),
    customer_id: parseInt(getUserId()),
    vmId: vendingMachineDetails.id,
    time: new Date().getTime(),
    phone_no: getUserPhone(),
    hash: getUserHashToken(),
  };

  //dispense now api payload
  let createApiPayload = {
    cUID,
    id: vendingMachineDetails.id,
    items: currentCartItems.map((element) => ({
      iQty: element.quantity,
      iUID: element.item.iUID,
      sid: element.item.sid,
    })),
    uuid: vendingMachineDetails.uuid,
    transaction_origin: 2,
    payMethod: null,
    time: new Date().getTime(),
    phone_no: getUserPhone(),
    hash: getUserHashToken(),
  };
  const handleDispenseNow = function (flag) {
    // if (response.oUID && response.payment_gateway === 5 && response.cUID) {
    if (location.state.oUID && cUID) {
      return history.push({
        pathname:
          APP_ROUTES.DISPENSING_ITEMS.rawUrl + location.state.oUID + "/" + cUID,
        state: {
          data: {
            dispenseLater: flag,
          },
        },
      });
    } else {
      triggerPaymentStatusModal(true);
    }
  };
  const handleDispenseFail = function (flag) {
    // if (response.oUID && response.payment_gateway === 5 && response.cUID) {
    if (location.state.oUID && cUID) {
      return history.push({
        pathname:
          APP_ROUTES.DISPENSING_ITEMS.rawUrl + location.state.oUID + "/" + cUID,
        state: {
          data: {
            dispenseLater: flag,
          },
        },
      });
    } else {
      triggerPaymentStatusModal(true);
    }
  };

  const triggerPaymentStatusModal = function (failure = false) {
    return setShowPaymentStatusModal({ failure });
  };
  const cancelOrderButton = (response) => {
    return history.push(APP_ROUTES.HOME_PAGE.url);
  };
  const onTimerComplete = () => {
    return history.push(APP_ROUTES.HOME_PAGE.url);
  };

  const startProductStatusPolling = function (dispenseTimeout) {
    requestPostFetchApi(API_KEYS.GET_VENDING_STATUS_OF_PRODUCTS, {
      order_id: location.state.oUID,
      phone_no: getUserPhone(),
      hash: getUserHashToken(),
    }).then((response) => {
      console.log("response.vend_status", response.vend_status);
      //Waiting for final status
      if (response.vend_status === DISPENSE_WAITING) {
      } else if (response.vend_status === DISPENSE_SUCCESS) {
        handleDispenseNow(true);
        return setVendStatusCompleted(true);
      } else {
        return handleDispenseNow(true);
      }
    });
  };

  useEffect(() => {
    // polling for vend status
    let myInterval = setInterval(
      startProductStatusPolling,
      API_POLLING_INTERVAL
    );
    return () => clearInterval(myInterval);
  }, []);

  return (
    <React.Fragment>
      {showPaymentStatusModal ? (
        <AlertModal
          open={true}
          modalTitle={componentTexts.unable_to_dispense_title}
          modalDescription={componentTexts.unable_to_dispense_desc}
        >
          <Link to={APP_ROUTES.HOME_PAGE.url}>
            <Button className="mt-1">Go To Dashboard</Button>
          </Link>
        </AlertModal>
      ) : (
        <>
          {/* <UserDetailsHeader vmName={"logo"} /> */}
          <section className="flex-container">
            <div className="pickup_code_hint">
              Pick Up Code to collect your items
            </div>
            <div className="order_success_pickup_code">
              <p>
                {componentTexts.pickup_code}&nbsp;:&nbsp;
                {/* <span className="pickup_code"> */}
                <span className="">{location.state.pickUp_code}</span>
              </p>
            </div>
            <div className="order_success_logo_heading">
              <p>
                {/* Enter above code on machine screen to collect your freebies */}
                Enter above code on{" "}
                <span
                  style={{
                    color: "#9D0202",
                    fontWeight: "bold",
                  }}
                >
                  "machine screen"
                </span>{" "}
                to {""}
                <span style={{ fontWeight: "bolder" }}>
                  collect your freebies
                </span>{" "}
                {/* (Top left corner) and enter your pickup code. */}
              </p>
            </div>

            <div className="dispense_circular_timer">
              <img
                src="/images/Vending_machine_new.png"
                // style={{
                //   width: "80vw",
                //   height: "280px",
                //   marginBottom: "25px",
                // }}
                className="dispense_vm_enter_code"
              />
              <br />
              <span>You can dispense your order within</span>
              <CountdownTimer
                num={
                  vendingMachineDetails.configurations.dispense_later_timeout
                  // *60 uncomment this to convert dispense_later_timeout into minutes
                }
                onTimerComplete={onTimerComplete}
              />
            </div>

           

            {/* <div className="input-area">
              <Button
                loaderApiKey={API_KEYS.CANCEL_ORDER}
                apiRequestBody={createCancelOrderPayload}
                onClick={cancelOrderButton}
              >
                {componentTexts.cancel_order}
              </Button>
            </div> */}
          </section>
        </>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  //   vendingMachine: state.vmDetailsReducer,
  //   vendingMachineItems: state.vmStockReducer.items,
  //   vendingMachineFilters: state.vmStockReducer.filters,
});

const mapDispatchToProps = (dispatch) => ({
  //   requestVMdetails: () => dispatch(requestVMdetails()),
  //   requestVmStock: () => dispatch(requestVmStock()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withToasts(DispenseLater));
